import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import Grid from '@material-ui/core/Grid'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'
import Skeleton from 'react-loading-skeleton'
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary'
import Styles from './styles'

class DisplayProductCardSkeleton extends Component {
  render () {
    const { cards } = this.props
    if (!cards) return null
    return this.skeleton(cards)
  }

  skeleton (cards) {
    var skeleton = []
    for (var i = 0; i < cards; i++) {
      skeleton.push(this.displayProductCardSkeleton(i))
    }
    return skeleton
  }

  displayProductCardSkeleton (i) {
    const { classes, mdSize } = this.props
    return (
      <Grid item key={i} xs={12} sm={12} md={mdSize} className={classes.col}>
        <Card square className={classes.colInside} style={{ minWidth: '300px', maxWidth: '400px', width: '100%' }}>
          <CardHeader
            title={<Skeleton count={1} />}
            subheader={<Skeleton count={1} />}
            style={{ textAlign: 'center' }}
          />
          <div className={classes.imageContainer}>
            <div style={{ maxWidth: '250px', margin: 'auto' }}>
              <PhotoLibraryIcon
                style={{ width: '100%', height: '100%', fontSize: '80px', color: 'rgba(133, 133, 133, .25)' }}
              />
            </div>
          </div>
          <CardContent style={{ paddingTop: 0, marginTop: '0px' }}>
            <Typography variant='subheading' align='center'>
              <Skeleton count={6} />
            </Typography>
          </CardContent>
          <CardActions>
            <Typography
              variant='subheading'
              align='center'
              style={{
                height: '37px',
                width: '100%',
                border: '1px solid #dfdfdf',
                borderRadius: '10px',
                paddingLeft: '10px',
                paddingRight: '10px',
                lineHeight: '37px'
              }}
            >
              <Skeleton count={1} />
            </Typography>
          </CardActions>
        </Card>
      </Grid>
    )
  }
}

export default withStyles(Styles)(DisplayProductCardSkeleton)



// WEBPACK FOOTER //
// ./src/common/display-product-card-skeleton.js